<template>
  <div class="loginmodal editorial-auth login-auth">
    <div class="modal-content">
      <div class="wrap">
        <div class="left">
          <img src="@/assets/img/mega-logo.png" alt="MEGA" />
          <div>
            <strong>로그인</strong>
            <span>계정 정보를 입력해 주세요</span>
          </div>
        </div>
        <div class="right">
          <!-- <h2><img src="@/assets/img/icon_dia.svg" />{{ $t('front.gnb.login') }}</h2> -->
          <ui-input :className="'logininput'" :type="'text'" :placeholder="$t('front.common.memId')" @input="getMemId"/>
          <ui-input :className="'logininput'" :type="'password'" :placeholder="$t('front.common.password')" @input="getMemPass" @keyup.enter="onSubmit"/>

          <section class="captcha-box">
            <VueClientRecaptcha
                :value="inputValue"
                :count="4"
                chars="12345"
                :hideLines="true"
                custom-text-color="black"
                @getCode="getCaptchaCode"
                @isValid="checkValidCaptcha"
            >
              <template>
                <span style="color: blue">with Custom Text Or Icon</span>
              </template>
            </VueClientRecaptcha>
            <input
                v-model="inputValue"
                placeholder="자동입력방지코드"
                class="input"
                type="text"
                @keyup.enter="onSubmit"
            />
          </section>
          <!-- <a class="finds">{{$t('front.common.memId')}}/{{$t('front.common.password')}} {{$t('front.common.find')}}</a> -->
          <ui-button :className="'loginnbtn on'" :text="$t('front.login.loginButton')"  @click.prevent="onSubmit" />
          <p class="jointxt">{{ $t('front.login.notFoundId') }}<ui-button :className="'joinnbtn'" :text="$t('front.common.signup')" @click="$emit('close', 'join')"/></p>
          <div class="loginclose" @click="$emit('close')"><img src="@/assets/img/icon_x.svg" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import UiButton from '@/components/ui/UiButton'
import UiInput from '@/components/ui/UiInput'

import { signIn } from '@/api/member'
import { setAuthData } from '@/libs/auth-helper'
import store from '@/store'

import VueClientRecaptcha from 'vue-client-recaptcha'

export default {
  name: 'Signin',
  components: {
    UiButton,
    UiInput,
    VueClientRecaptcha
  },
  computed: {
    canSubmit () {
      return this.model.memId && this.model.memPass
    }
  },
  data () {
    return {
      model: {
        memId: '',
        memPass: ''
      },
      data: {
        captchaCode: null,
        isValid: false
      },
      inputValue: null
    }
  },
  methods: {
    getCaptchaCode (value) {
      this.data.captchaCode = value
    },
    checkValidCaptcha (value) {
      this.data.isValid = value
    },
    getMemId (value) {
      this.model.memId = value
    },
    getMemPass (value) {
      this.model.memPass = value
    },
    setReloadCaptcha () {
      setTimeout(() => {
        if (document.querySelector('.vue_client_recaptcha_icon')) {
          document.querySelector('.vue_client_recaptcha_icon').click()
        }
      }, 500)
    },
    async onSubmit () {
      let reloadCaptcha = false
      if (!this.data.isValid) {
        reloadCaptcha = true
        await this.onAlert('warningart', '자동 입력 방지 코드를 확인해주세요.')
      }

      if (this.model.memId === '') {
        reloadCaptcha = true
        this.onAlert('warningart', 'front.signin.emptyMemId')
      }
      if (this.model.memPass === '') {
        reloadCaptcha = true
        this.onAlert('warningart', 'front.signin.emptyMemPass')
      }

      if (!this.canSubmit) {
        reloadCaptcha = true
      }

      if (reloadCaptcha) {
        this.setReloadCaptcha()
        return false
      }

      /*
      * api/member.js 참고
      */
      signIn(this.model).then(async response => {
        const result = response.data
        const data = result.data

        if (result.resultCode === '0') {
          setAuthData(data)
          store.commit('setUserData', data.member)
          store.dispatch('storeCommonCode').then(commonCode => {
            if (data.msgInfo) {
              store.dispatch('storeUserUnReadMessageCount', data.msgInfo.newMsg)
            }
            this.$emit('close', 'signin')
          })

          // setTimeout(function () {
          //   this.$emit('close', 'signin')
          // }.bind(this), 100)
        } else if (result.resultCode === 'U001' || result.resultCode === 'LX02') {
          await this.onCheck('err.' + result.resultCode)
          this.setReloadCaptcha()
        } else {
          // const confirm = await this.onConfirm('api.' + result.resultCode)
          // if (confirm) {
          //   this.$emit('signup')
          // }
          await this.onCheck('로그인정보가 올바르지 않습니다. 확인해주세요.')
          this.setReloadCaptcha()
        }
      }).catch(err => {
        console.error('login err : ', err.message)

        if (err.message === 'no member') {
          // alert('로그인정보가 올바르지 않습니다. 확인해주세요.')
          this.onCheck('로그인정보가 올바르지 않습니다. 확인해주세요.')
        } else {
          alert(err.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.captcha-box { margin-top: 10px;width: 100%;height: 40px;display: flex;align-items: center; }
.captcha-box .vue_client_recaptcha {
  background-color: #fff;
  width: 50%;
  height: 40px;
  display: flex;
  align-items: center;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 16%);
}

/deep/ .captcha-box .vue_client_recaptcha .vue_client_recaptcha_icon {
  float: right;
  display: inline-block;
}
/deep/ #captcha_canvas {width: 100px;}
.captcha-box .input {
  position: relative;
  width: calc(50% - 10px);
  height: 40px;
  text-align: center;
  font-size: 14px;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 16%);
  border: 1px solid #444;
  border-radius: 0 4px 4px 0;
  box-sizing: border-box;
  background-color: #131313;
  color: #fff;
  vertical-align: top;
}
</style>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>

<style scoped>
.editorial-auth {background:rgba(5,5,6,.82);backdrop-filter:blur(6px)}
.login-auth .modal-content {width:376px;margin:0;border:1px solid #34312d;border-radius:10px;padding:0;background:#141416;background-image:none;box-shadow:0 24px 70px rgba(0,0,0,.55)}
.login-auth .modal-content>.wrap {padding:24px;background:#141416;border-radius:10px;box-shadow:none}
.login-auth .modal-content .left {margin:0 0 22px;padding-bottom:18px;border-bottom:1px solid #29292d;justify-content:flex-start;gap:14px}
.login-auth .modal-content .left img {width:112px;height:auto}
.login-auth .modal-content .left>div {display:flex;flex-direction:column;gap:5px}
.login-auth .modal-content .left strong {color:#eeeae6;font-size:17px}
.login-auth .modal-content .left span {color:#77736f;font-size:9px}
.login-auth :deep(.logininput) {height:42px;margin-top:8px;padding:0 13px;border:1px solid #302f30;border-radius:6px;background:#101012;box-shadow:none;color:#eeeae6;font-size:11px;outline:none}
.login-auth :deep(.logininput::placeholder) {color:#66635f}
.login-auth :deep(.logininput:focus) {border-color:#806b42;background:#111113}
.login-auth .captcha-box {height:42px;margin-top:8px;gap:6px}
.login-auth .captcha-box .vue_client_recaptcha {width:50%;height:42px;border:1px solid #302f30;border-radius:6px;background:#dedbd3;box-shadow:none;box-sizing:border-box;overflow:hidden}
.login-auth .captcha-box .input {width:50%;height:42px;border:1px solid #302f30;border-radius:6px;background:#101012;box-shadow:none;color:#eeeae6;font-size:11px;outline:none}
.login-auth .captcha-box .input:focus {border-color:#806b42}
.login-auth :deep(.loginnbtn.on) {height:40px;margin-top:12px;border:1px solid #8a7042;border-radius:6px;background:#8a7042;box-shadow:none;color:#f7f3eb;font-size:12px;line-height:40px;text-shadow:none}
.login-auth :deep(.loginnbtn.on:hover) {background:#9a8050}
.login-auth .jointxt {margin:14px 0 0;color:#77736f;font-size:10px}
.login-auth :deep(.joinnbtn) {margin-left:5px;color:#bda36f;text-decoration:none}
.login-auth .loginclose {right:14px;top:14px}
.login-auth .loginclose img {width:18px;height:18px;opacity:.55}
</style>
